import axios from 'axios';
import { API_PLAN,API_PLAN_ZONA, HEADERS, ID_CUENTA } from 'config/general/Configuracion';

class ApiClient {
  constructor() {
  }

  listarPlan = (paginacion) => {
    const query = `limite=${paginacion.limite}&actual=${
      paginacion.actual
    }&filtro=${paginacion.filtro || ''}&orden=${paginacion.orden ||
      'plan'}&sentido=${paginacion.sentido || 'ASC'}`;
    return axios.get(
      `${API_PLAN}/v1/plan/listado/${sessionStorage[ID_CUENTA]}?${query}`,
      {
        headers: HEADERS(),
      }
    );
  };
  
  listarPlanZona = (paginacion) => {
    const query = `limite=${paginacion.limite}&actual=${
      paginacion.actual
    }&filtro=${paginacion.filtro || ''}&orden=${paginacion.orden ||
      'planZona'}&sentido=${paginacion.sentido || 'ASC'}`;
    return axios.get(
      `${API_PLAN_ZONA}/v1/planZona/listado/${sessionStorage[ID_CUENTA]}?${query}`,
      {
        headers: HEADERS(),
      }
    );
  };

  listarZonaActiva = () => {
    return axios.get(
      `${API_PLAN_ZONA}/v1/planZona/listadoZonas/${sessionStorage[ID_CUENTA]}`,
      {
        headers: HEADERS(),
      }
    );
  };

  guardarPlan = (plan) => {
    let respuesta = {
      method: "post",
      url: `${API_PLAN}/v1/plan/guardar/${encodeURIComponent(
        sessionStorage[ID_CUENTA]
      )}`,
      headers: HEADERS(),
      data: plan,
    };
    return respuesta;
  };

  guardarPlanZona = (planZona) => {
    let respuesta = {
      method: "post",
      url: `${API_PLAN_ZONA}/v1/planZona/guardar/${encodeURIComponent(
        sessionStorage[ID_CUENTA]
      )}`,
      headers: HEADERS(),
      data: planZona,
    };
    return respuesta;
  };


 
}

const PlanApi = new ApiClient();
export default PlanApi;
